import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import OrderPage from './OrderPage';

const OrderPageRoute: React.FC = () => {
    const { symbol, orderId } = useParams();
    const [searchParams] = useSearchParams();
    const date = searchParams.get('date');

    if (!symbol || !orderId || !date) {
        return (
            <div className='OrderPageError'>
                <h4>Missing parameters</h4>
                <p>URL must include symbol, order ID and date. Example: /order/MAREL/12345?date=2026-04-15</p>
            </div>
        );
    }

    return <OrderPage symbol={symbol} orderId={orderId} date={date} />;
};

export default OrderPageRoute;
